import { QueryCache, QueryClient } from "@tanstack/react-query"
import * as Sentry from "@sentry/tanstackstart-react"

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      console.error(error)

      // future:
      // toast.error(...)
      Sentry.captureException(error)
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 0, // 5 min
      gcTime: 0, // 30 min

      retry: (failureCount, error) => {
        if (error instanceof Error) {
          // Don't retry auth errors
          if (error.message.includes("401")) {
            return false
          }
        }

        return failureCount < 2
      },

      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),

      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      refetchOnMount: true,
    },

    mutations: {
      retry: 1,
    },
  },
})
